import { render, staticRenderFns } from "./Prediction.vue?vue&type=template&id=4e6f1a68"
import script from "./Prediction.vue?vue&type=script&lang=js"
export * from "./Prediction.vue?vue&type=script&lang=js"
import style0 from "./Prediction.vue?vue&type=style&index=0&id=4e6f1a68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports